import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentRef } from '@ng-bootstrap/ng-bootstrap/util/popup';

@Component({
  selector: 'app-iframe-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button (click)="onClose()" type="button" class="btn btn-secondary align-self-start">X<i class="fa-solid fa-xmark"></i></button>
    </div>
    <div class="modal-body" *ngIf="url">
      <iframe #iframe [src]="url | safe" frameborder="0" width="100%" height="500px" [hidden]="isLoading" (load)="onIframeLoad()"></iframe>

      <div *ngIf="isLoading" style="width: 100%; height: 500px;" class="d-flex justify-content-center align-items-center">
        <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status"></div>
      </div>
    </div>`,
})
export class IframeModalComponent {
  @Input() public url: string | undefined;
  @Input() public title: string | undefined;

  isLoading = true

  @ViewChild('iframe')
  iframe?: ElementRef;

  constructor(private modalRef: NgbActiveModal) {
  }
  @HostListener('window:message', ['$event'])
  private handlePostMessage(msg: MessageEvent) {
    if (msg.data && msg.data.type === 'door_vision_pop_up_close') {
      this.onClose();
    }
  }

  onIframeLoad(): void {
    if (this.iframe) {
     this.isLoading = false;
    }
  }

  public onClose(): void {
    this.modalRef.close();
  }
}
